import { render, staticRenderFns } from "./CallSuportDialog.vue?vue&type=template&id=3e95e604&scoped=true"
import script from "./CallSuportDialog.vue?vue&type=script&lang=js"
export * from "./CallSuportDialog.vue?vue&type=script&lang=js"
import style0 from "./CallSuportDialog.vue?vue&type=style&index=0&id=3e95e604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e95e604",
  null
  
)

export default component.exports